import { attribute, clickable, hasClass } from 'ember-cli-page-object';

export const selector = '[ data-test-stepper-form-tab ]';
export default (scope = selector) => ({
  scope,

  isActive: hasClass('is-active'),
  isComplete: hasClass('is-complete'),
  icon: attribute('data-test-icon', '[data-test-icon]'),
  isDisabled: attribute('disabled', 'button'),
  click: clickable('button'),
});
